import jsonapi from 'jsonapi-parse';
import ProofreadingOrder from '../../js/ReadModel/Order/ProofreadingOrder';
import AssignmentHelper from '../../js/Helpers/AssignmentHelper';

export default class ProofreadingOrderFactory {
    static fromApiResponse(proofreadingApiResponse, assignmentPoolsResponse = null) {
        let order = jsonapi.parse(proofreadingApiResponse).data;

        if (assignmentPoolsResponse) {
            let assignmentPools = jsonapi.parse(assignmentPoolsResponse).data;

            order.assignments.forEach(assignment => {
                assignment.assignmentPools = assignmentPools.filter(assignmentPool => assignmentPool.assignmentId === assignment.id);
            });
        }

        order.assignments = AssignmentHelper.sort(order.assignments);
        order.assignments = AssignmentHelper.nest(order.assignments);

        return new ProofreadingOrder(order);
    }
}
